<button
  *ngIf="!enableFormButton; else renderFormButton"
  #button
  shrdUicButton
  type="button"
  variant="tertiaryFlyout"
  [ngClass]="className"
  [attr.disabled]="disabled || undefined"
  [attr.tabindex]="selected ? 0 : -1"
>
  <span *ngIf="label" [innerHTML]="label | highlightText: highlightedContent"></span>
  <ng-content></ng-content>
  <shrd-uic-svg-icon *ngIf="selected" icon="tick" size="small"></shrd-uic-svg-icon>
</button>

<ng-template #renderFormButton>
  <shrd-uic-form-button
    #formButton
    class="d-block mt-md-n1"
    type="checkbox"
    [ariaLabelSelected]="label"
    [ariaLabelUnselected]="label"
    [selected]="selected"
    [disabled]="disabled || undefined"
  >
    <span *ngIf="label" [innerHTML]="label | highlightText: highlightedContent"></span>
  </shrd-uic-form-button>
</ng-template>
